var React = require('react');

function Home (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M859.47,394.3v-211.02h-180.43v52.02l-139.04-122.52L5.98,583.37h169.97v375.52h295.48v-270.53h137.14v270.53h295.48v-375.52h169.97l-214.55-189.07ZM854.05,533.37v375.52h-195.48v-270.53h-237.14v270.53h-195.48v-375.52h-87.6l401.65-353.94,189.04,166.58v-112.72h80.43v183.6l132.19,116.48h-87.6Z"}));
}

Home.defaultProps = {"id":"ICONS","width":"15in","height":"15in","version":"1.1","viewBox":"0 0 1080 1080"};

module.exports = Home;

Home.default = Home;
